import { clsxMerge } from "shared/lib/helpers";
import { TextField } from "shared/ui/user-input";

import { FC, useEffect, useState } from "react";
import { useEmailTemplatesContext } from "@/components/modules/email-templates-sidebar/context";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { useUpdateTemplate } from "@/components/modules/email-templates-sidebar/queries";
import { Button } from "shared/ui/shadcn/button";

import { swallow } from "@/api/legacy-swallow";

const SimpleTextField = TextField();

export const EmailPromptNameInput: FC<
  PropsWithClassNameI & { onSave?: () => void }
> = ({ onSave, className }) => {
  const { activeTemplate } = useEmailTemplatesContext();
  const { mutateAsync: updateTemplate, isPending: isLoading } =
    useUpdateTemplate();

  const [promptName, setPromptName] = useState<string | undefined>(
    activeTemplate?.name
  );

  const handlePromptNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPromptName(e.target.value);
  };

  const handleOnSave = async () => {
    if (isLoading) return;

    const resp = await swallow(
      updateTemplate({
        templateId: activeTemplate?.id as string,
        params: { name: promptName },
      })
    );

    if (resp.status !== 200) {
      return;
    }

    onSave?.();
  };

  useEffect(() => {
    setPromptName(activeTemplate?.name);
  }, [activeTemplate?.name]);

  return (
    <div className={clsxMerge("animate-fadein", className)}>
      <div className={clsxMerge("mb-2 flex items-center justify-between")}>
        <h6 className="typography-body-4-medium">Email prompt name</h6>
      </div>
      <div className="relative">
        <SimpleTextField
          name="prompt-name"
          placeholder="Enter prompt name"
          className={clsxMerge("mb-2")}
          inputClassName={clsxMerge(
            "border-[#ccc] bg-white pr-16 typography-body-4-medium placeholder:text-[#666]"
          )}
          inputProps={{
            value: promptName,
            onChange: handlePromptNameChange,
          }}
        />
        <Button
          variant="outline"
          size="sm"
          onClick={handleOnSave}
          className="absolute right-[6px] top-[6px]"
          disabled={isLoading}
          loading={isLoading}
        >
          Save
        </Button>
      </div>
    </div>
  );
};
